/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Friends(props) {
    return (
        <SvgIcon {...props}>
            <path d="M8.671,10.943c0,0-2.273-0.43-2.567-0.463C5.813,10.447,5.39,9.49,5.422,8.93 c0.034-0.56,1.495-1.582,1.333-4.55c0,0,0.029-2.769-2.618-2.769c-0.014,0-0.032,0.001-0.047,0.001 c-0.015,0-0.031-0.001-0.048-0.001C1.396,1.611,1.429,4.38,1.429,4.38c-0.162,2.968,1.298,3.99,1.333,4.55 c0.031,0.56-0.392,1.517-0.683,1.55C1.873,10.503,0.684,10.721,0,10.849v2.763h10.146C10.057,12.533,9.736,11.122,8.671,10.943z" />
            <path d="M14.6,8.444c-0.246-0.04-1.34-0.25-1.724-0.31c-0.089-0.13-0.217-0.46-0.207-0.62 c0.01-0.04,0.089-0.16,0.148-0.25c0.305-0.48,0.876-1.38,0.788-2.97c0-0.05,0-1.07-0.669-1.76c-0.404-0.41-0.926-0.61-1.655-0.61 c-0.65,0-1.182,0.2-1.576,0.61c-0.67,0.69-0.67,1.71-0.67,1.73c-0.088,1.62,0.483,2.52,0.788,3c0.059,0.09,0.138,0.21,0.148,0.23 c0.01,0.18-0.119,0.51-0.207,0.64c-0.295,0.05-1.024,0.18-1.448,0.26c0,0-0.739,0.11-0.798,0.9l0.345,0.05 c0.669,0.12,1.891,0.35,2.177,0.4c0.768,0.13,1.29,0.79,1.546,1.96l0.069,0.34h4.305l0.029-0.4 C16.008,11.344,16.146,8.714,14.6,8.444z" />
        </SvgIcon>
    );
}

Friends.defaultProps = {
    viewBox: '0 0 16 16'
};

export default Friends;
